/*
 *
 * ResultPopUp
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 23-Jan-2025
 */

import { connect } from 'react-redux'
import ResultPopUp from './ResultPopUp'
import { doPopup } from 'Store/actions/popup'
import { getPopupData } from 'Store/selectors'

const mapDispatchToProps = (dispatch) => ({
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  data: getPopupData(state)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ResultPopUp)
